<template>
        <!-- Splash Screen Start -->
    <div class="preloader inset-0 z-50 absolute " :style="{display:loadr}">
      <div class="h-full bg-bgColor flex flex-col justify-center items-center text-center container">
        <div class="zoomInOut">
          <div class="">
            <img src="../../public/asset/logo2.png" alt="" style="width: 200px;">
          </div>
          <p class="pt-6 text-4xl font-bold text-n900">
            Kiyan <span class="text-g300">Rahayu</span>
          </p>
        </div>
      </div>
    </div>
    <!-- Splash Screen End -->

       <div class="px-6 flex justify-between items-start">       

         

        <a href="https://softivuspro.com/html/bankux/main-demo/notifications.html" class="text-2xl   !leading-none flex justify-center items-center rounded-full   relative bg-white dark:bg-n0">
            <img src="../../public/asset/logo2.png" alt="" style="width: 60px;height: 60px;">
        </a>
      </div>
      <div class="text-center flex justify-between items-center flex-col py-8">
        <div class="rounded-full  overflow-hidden bg-bgColor2" :style="{width: '100px',height: '100px',border: 'solid 6px ' + activeColor  }">
          <img src="../../public/asset/avatar.jpg" alt="" style="width: 100px;height: 100px;">
        </div>
         <p class="font-semibold">
                {{ nama }}
              </p>
        <p class="text-[52px] font-bold flex justify-start mt-3">
          {{ currentTime.toLocaleTimeString('en-GB',  {hour: '2-digit', minute:'2-digit'}) }} 
        </p>
        <p>{{ currentTime.toLocaleDateString([],{ day: 'numeric' , month: 'long',year: 'numeric'}) }}</p>

       
        
      </div>
 

  

         <div v-if ="isaktif === 'DONE'"  class="px-6 relative z-20">
          <a href="#" class="bg-g300 rounded-2xl py-5 px-6 flex justify-between items-center">
            <div class="w-1/2">
              <p class="text-white text-xl font-semibold">
              Status Selesai Untuk Hari ini
              </p>
              <p class="text-white text-xs pt-1.5">
                jam kerja : {{total}}
              </p>
               
            </div>
            <div class="">
              <img src="../../public/asset/pay-bill-illus.png" alt="">
            </div>
          </a>
        </div>

        <div v-if ="isaktif === 'ABSEN'"  class="px-6 relative z-20">
          <a href="#" class="bg-g300 rounded-2xl py-5 px-6 flex justify-between items-center">
            <div class="w-1/2">
              <p class="text-white text-xl font-semibold">
              Ayo Absen Dulu
              </p>
              <p class="text-white text-xs pt-1.5">
                Klik Tombol absen untuk mulai <br /><br />
              </p>
              <router-link  to="/absen" class="text-sm px-4 py-2 mt-4 rounded-md bg-o300 text-white">
              Absen
            </router-link>
               
            </div>
            <div class="">
              <img src="../../public/asset/absen.png" alt="" style="width: 120px;">
            </div>
          </a>
        </div>

          <div v-if ="isaktif === 'AKTIF'"  class="px-6 relative z-20">
          <a href="#" class="bg-g300 rounded-2xl py-5 px-6 flex justify-between items-center">
            <div class="w-1/2">
              <p class="text-white text-xl font-semibold">
              Selamat Bekerja 
              </p>
              <p class="text-white text-sm pt-2"> 
               {{ text1 }}
            </p><br /> 
              <div class="text-sm px-4 py-2 rounded-md bg-o300 text-white" @click="showModal = true">
              Checkout
            </div>
               
            </div>
            <div class="">
              <img src="../../public/asset/work.png" alt="" style="width: 120px;">
            </div>
          </a>
        </div>


     <div class="bg-white rounded-t-3xl pt-14 -mt-14 flex-1 pb-32 dark:bg-n0">
    
        
        <div class="px-6 pt-8">
          <div class="flex justify-between items-center">
            <p class="text-xl font-semibold">Riwayat Absensi</p>
            <a href="#" class="text-g300 font-semibold text-sm">
              View All</a>
          </div>
          <div class="flex flex-col gap-4 pt-6">
           
           <template  v-for="item in items" :key="item.id_pre"> 
             
            <router-link :to="{ name: 'detail', params: { id:  item.id_pre } }"    class="flex justify-between items-center border-b border-dashed border-n40 dark:border-darkN40 pb-4">
              <div class="flex justify-start items-center gap-4">
                <div class="rounded-full bg-bgColor2 dark:bg-darkN40 overflow-hidden">
                  <img src="../../public/asset/people-1.png" alt="" class="w-[60px] h-[60px] object-cover">
                  
                </div>
                <div class="">
                  <p class="font-semibold">{{item.tanggal}}</p>
                  <p v-if="item.sts == 'IZIN'" class="text-n500 dark:text-darkN500 text-xs pt-2.5">
                   Ket : {{item.keterangan}}  
                  </p>
                  <p v-else  class="text-n500 dark:text-darkN500 text-xs pt-2.5">
                    {{item.jam_chekin}} s/d   {{item.jam_checkout}}
                  </p>
                </div>
              </div>
              <div class="flex flex-col justify-end items-end">
                <p class="font-semibold pb-2"> </p>
                <p class="text-orange-500 text-xs py-0.5 px-2 bg-orange-200 rounded-md dark:bg-darkN40">
                  {{item.sts}}
                </p>
              </div>
            </router-link> 
            </template> 
            
 
      
       
       
          </div>
        </div>
      </div>

      

      <NavAdmin v-if="rolex =='ADMIN'"></NavAdmin>
      <NavView v-else ></NavView>


  <transition name="fade" appear>
    <div class="modal-overlay" 
         v-if="showModal" 
        ></div>
  </transition>
  <transition name="pop" appear>
    <div class="modal" 
         role="dialog" 
         v-if="showModal"
         >
      <h1>Lanjut Ke check out?</h1>

       <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
      
      <button   @click="cekout()" class="flex-1 py-3 bg-g300 text-white text-center rounded-xl font-medium border border-g300 px-6" >Check Out</button>
       <button   @click="showModal=false" class="flex-1 py-3  bg-bgColor2 text-white text-center rounded-xl font-medium border border-g300 px-6" style="margin-left:10px;">Cancel</button>

    </div>
  </transition>
      
</template>

<script setup >
 
import { onMounted,ref} from 'vue'
import NavView from '../components/NavView.vue'
import NavAdmin from '../components/NavAdmin.vue'
import { useRouter } from "vue-router";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  

 
 
let  text1 = ref("Lokasi Belum Tepat")
let  nama = ref("-")
const  rolex = ref("USER")
const showModal = ref(false)
const loading = ref(false)
const activeColor = ref('red')
const router = useRouter();
const sts_absen = ref(false)
let total = ""
const items = ref([])
const loadr = ref('block')
const latlng = ref()
const isaktif = ref('ABSEN')
 

 

 const { currentTime } = useCurrentTime();
  
 
 
 

onMounted(async () => {
  
  const token = localStorage.getItem("token");

  const res = await fetch("https://kiyanrahayu.my.id/api2/status",{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       }
    })

  if(res.ok){
  const status2 = await res.json() 
  latlng.value = status2.latlng
 
   nama.value = status2.message.name
   rolex.value = status2.message.role
   items.value = status2.history
  if(status2.sts){
    if(status2.sts.sts == 'AKTIF'){
      isaktif.value = 'AKTIF'
      text1.value = "Jam Absen : " + status2.sts.jam_chekin
      activeColor.value = 'green'
      loadr.value='none'
    }else{
      isaktif.value = 'DONE'
      sts_absen.value = true
      total = status2.sts.jam_chekin + " s/d " + status2.sts.jam_checkout
       activeColor.value = '#fff'
       loadr.value='none'
    }
       
  }else{
 loadr.value='none'   
 isaktif.value = 'ABSEN'
  }
}else{
  logout();
}

  //console.log(status2)

//  const user =  JSON.parse(localStorage.getItem("user"))
  
 
})

 
async function cekout(){
  loading.value = true
  const token = localStorage.getItem("token");

  const formData = new FormData()
  formData.append("cmd","cekout")

  const res = await fetch("https://kiyanrahayu.my.id/api2",{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       },
       method: "POST",
       body: formData
    })
  const data = await res.json() 
   if (res.ok) {
        showModal.value = false
        loading.value = false
        if(data.sts){
          router.push("/cekout");
        } 

    } 
}

function logout(){
 localStorage.removeItem("token");
 localStorage.removeItem("user");
  router.push("/login");

}


 

</script>

<script>
import { useCurrentTime } from "../composable/useCurrentTime";
export default {
  name: "CurrentTimeExample",
 
};
</script>

<style scoped>
.page { padding: 20px; }

.modal {
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  height: fit-content;
  max-width: 22em;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: #FFF;
  z-index: 999;
  transform: none;
}
.modal h1 {
  margin: 0 0 1rem;
}

.modal-overlay {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

/* ---------------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}

</style>
